import { render, staticRenderFns } from "./ButtonAddItem.vue?vue&type=template&id=87152a7c&"
import script from "./ButtonAddItem.vue?vue&type=script&lang=js&"
export * from "./ButtonAddItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87152a7c')) {
      api.createRecord('87152a7c', component.options)
    } else {
      api.reload('87152a7c', component.options)
    }
    module.hot.accept("./ButtonAddItem.vue?vue&type=template&id=87152a7c&", function () {
      api.rerender('87152a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/ButtonAddItem.vue"
export default component.exports